<script setup lang="ts">


import type {Currency} from "~/types/subscription.types";

const connections = defineModel<number>()

defineProps<{
  currency: Currency,
  planType: string,
}>()

</script>
<template>
  <div class="connections-chooser">
    <v-slider v-model="connections" min="5" max="100" step="1" color="primary" class="mt-2" hide-details/>
    <div class="d-flex justify-space-between">
      <div>Number of connections:
        <FormattedNumber :number="connections"/>
        <div>
          <MenuTooltipLink open-on-click class="d-inline">
            <template v-slot:default>
              How are connections calculated?
            </template>

            <template v-slot:tooltip>
              <p>
                Axon Framework applications connect to a context. When they connect to multiple contexts, they count as
                multiple connections.
              </p>
              <p>So, if the Order application connects to the <code>order</code> context, as well as the
                <code>warehouse</code> context, while the Warehouse service only connects to the <code>warehouse</code>
                context,
                this requires a total of 3 connections.</p>
            </template>
          </MenuTooltipLink>
        </div>
      </div>
      <div class="d-flex mr-3">
        <PriceBasedOnQuantity :plan="planType" :quantity="connections ?? 0" :currency="currency ?? 'USD'"/>
        <div class="text-end">/month</div>
      </div>
    </div>
  </div>
</template>
